<template>
  <div id="index">
    <div class="imgBg">
<!--      <img style="position: absolute;z-index: 1;left: 0;right: 50%;top: 0;-->
<!--bottom: 0" src="../../../assets/loginBg.jpg" height="100%" width="45%"/>-->
      <div class="loginDiv">
        <div>
          登录中
        </div>
<!--        <p><span class="font18 dis_line m_b_10">{{$t('common.Email')}}</span><br><input @keyup.enter="goToIndex()" v-model="account" :placeholder="$t('common.InputEmail')" type="text"></p>-->
<!--        <p><span class="font18 dis_line m_b_10">{{$t('common.Password')}}</span><br><input @keyup.enter="goToIndex()" v-model="myPassword" :placeholder="$t('common.InputPassword')" type="password"></p>-->
<!--        <button style="width: 150px" class="redButton" @click="goToIndex()">{{$t('common.Login')}}</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// import axiox from "../../assets/js/axios"
export default {
  name: 'index',
  data () { // 所有的数据都写在里面
    return {
      msg: '',
      account: '',
      myPassword: '',
      token: this.$route.query.token,
      takedacode: this.$route.query.takedacode,
      //需要删除注释
      // takedacode:'aba86aa8-3b8b-4411-a0bb-83d3657e0c7f',
      // email: this.$route.query.email,
      returnUrl: window.localStorage.getItem('returnUrl') || '',
      appId: window.localStorage.getItem('appId') || '',
      openId: window.localStorage.getItem('openId') || '',
      code: this.$route.query.code || '' // 员工号
    }
  },
  created () {
    let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
    let mobile = !!userAgent.match(/AppleWebKit.*Mobile.*/) // 是否为移动终端
    console.log(this.returnUrl, 'returnUrl')
    console.log(this.appId, 'appId')
    console.log(this.openId, 'openId')
    if (this.takedacode) {
      this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
        console.log(msg)
        // console.log(msg.token)

        let newOpenId = msg.openId || localStorage.openId
        let newToken = msg.token 


        if (newToken) {
          window.localStorage.setItem('TaToken', newToken)
          this.$axiox.get('/api/product/cateGory/query').then(p => {
            window.localStorage.setItem('canEditList', JSON.stringify(p))
          })
          let userInfoUrl = ''
          if (newOpenId && this.code) {
            userInfoUrl = `/Login/BindingEmployee?openId=${newOpenId}&code=${this.code}`
          } else if (newOpenId) {
            userInfoUrl = `/Login/wechatUserinfo?openId=${newOpenId}`
          } else {
            userInfoUrl = `/Login/userinfo`
          }
          this.$axiox.get(userInfoUrl).then(p => {
            console.log(p, '用户信息！！！！！！！！！！！！！！')
            if (newOpenId && this.code) {
              window.localStorage.setItem('TaToken', p.token)
            }
            window.localStorage.setItem('userInfo', JSON.stringify(p))
            this.$axiox.post('/api/authoritymenu/GetAllMenusByUser/usermenus', {userId: p.id}).then(p2 => {
              window.localStorage.setItem('usermenus', JSON.stringify(p2 || []))
              this.$axiox.get('/api/employeerole/Gets?pageIndex=1&pageSize=9999').then(p3 => {
                for (let i = 0; i < p3.length; i++) {
                  if (p3[i].role === 'Administrator') {
                    this.$axiox.get('/api/employeerole/GetEmps?roleId=' + p3[i].id + '&PageSize=9999&PageIndex=1&').then(p4 => {
                      let flag = false
                      for (let j = 0; j < p4.length; j++) {
                        if (p4[j].employeeId === p.id) {
                          flag = true
                        }
                      }
                      if (flag) {
                        window.localStorage.setItem('isAdmin', 'true')
                      } else {
                        window.localStorage.setItem('isAdmin', 'false')
                      }
                      let usermenus = p2 || []
                      for (let i = 0; i < usermenus.length; i++) {
                        console.log(usermenus[i].name)
                        if (usermenus[i].name) {

                        }
                      }
                      // if (newOpenId && newOpenId !== undefined && newOpenId !== null) {
                      if (mobile) {
                        // 手机端登录
                        window.localStorage.setItem('isEmployee', true)
                        console.log(this.appId, 'this.appId')
                        console.log(this.returnUrl, 'this.returnUrl')
                        if (this.returnUrl) {
                          console.log(decodeURIComponent(this.returnUrl), 'decodeURIComponent(this.returnUrl)')
                          setTimeout(p => {
                            window.location.href = this.$commonJs.returnQuery2(decodeURIComponent(this.returnUrl), {})
                          }, 2000)
                          // window.localStorage.removeItem('appId')
                          // window.localStorage.removeItem('openId')
                          window.localStorage.removeItem('returnUrl')
                        } else {
                          this.$commonJs.closeWindow()
                          // window.localStorage.removeItem('appId')
                          // window.localStorage.removeItem('openId')
                          window.localStorage.removeItem('returnUrl')
                        }
                      } else {
                        if (p2[0]) {
                          this.$router.push({
                            name: p2[0].url
                          })
                          setTimeout(p => {
                            window.location.reload()
                          }, 10)
                        } else {
                          this.$router.push({
                            name: 'noPermission'
                          })
                        }
                      }
                    })
                  }
                }
              })
              // let rolesMenu = await axiox.asyncGet('/api/employeerole/Gets?pageIndex=1&pageSize=9999')
              // console.log(rolesMenu)
              // Vue.prototype.$rolesMenu = rolesMenu
              // for (let i = 0; i < rolesMenu.length; i++) {
              //   if (rolesMenu[i].role === 'Administrator') {
              //     let adminList = await axiox.asyncGet('/api/employeerole/GetEmps?roleId=' + rolesMenu[i].id + '&PageSize=9999&PageIndex=1&')
              //     console.log(adminList)
              //     for (let j = 0; j < adminList.length; j++) {
              //       if (adminList[j].employeeId === loginInfo.id) {
              //         window.localStorage.setItem('isAdmin', 'true')
              //       } else {
              //         window.localStorage.setItem('isAdmin', 'false')
              //       }
              //     }
              //   }
              // }
            })
          })
          // this.goUrl()
        }
      })
    }
    // if (this.token) {
    //   window.localStorage.setItem('TaToken', this.token)
    //   this.$axiox.get('/api/product/cateGory/query').then(p => {
    //     window.localStorage.setItem('canEditList', JSON.stringify(p))
    //   })
    //   let userInfoUrl = ''
    //   if (this.openId && this.code) {
    //     userInfoUrl = `/Login/BindingEmployee?openId=${this.openId}&code=${this.code}`
    //   } else if (this.openId) {
    //     userInfoUrl = `/Login/wechatUserinfo?openId=${this.openId}`
    //   } else {
    //     userInfoUrl = `/Login/userinfo`
    //   }
    //   this.$axiox.get(userInfoUrl).then(p => {
    //     console.log(p, '用户信息！！！！！！！！！！！！！！')
    //     if (this.openId && this.code) {
    //       window.localStorage.setItem('TaToken', p.token)
    //     }
    //     window.localStorage.setItem('userInfo', JSON.stringify(p))
    //     this.$axiox.get('/api/authoritymenu/GetAllMenusByUser/usermenus?userId=' + p.id).then(p2 => {
    //       window.localStorage.setItem('usermenus', JSON.stringify(p2 || []))
    //       this.$axiox.get('/api/employeerole/Gets?pageIndex=1&pageSize=9999').then(p3 => {
    //         for (let i = 0; i < p3.length; i++) {
    //           if (p3[i].role === 'Administrator') {
    //             this.$axiox.get('/api/employeerole/GetEmps?roleId=' + p3[i].id + '&PageSize=9999&PageIndex=1&').then(p4 => {
    //               let flag = false
    //               for (let j = 0; j < p4.length; j++) {
    //                 if (p4[j].employeeId === p.id) {
    //                   flag = true
    //                 }
    //               }
    //               if (flag) {
    //                 window.localStorage.setItem('isAdmin', 'true')
    //               } else {
    //                 window.localStorage.setItem('isAdmin', 'false')
    //               }
    //               let usermenus = p2 || []
    //               for (let i = 0; i < usermenus.length; i++) {
    //                 console.log(usermenus[i].name)
    //                 if (usermenus[i].name) {
    //
    //                 }
    //               }
    //               if (this.openId) {
    //                 // 手机端登录
    //                 window.localStorage.setItem('isEmployee', true)
    //                 console.log(this.appId, 'this.appId')
    //                 console.log(this.returnUrl, 'this.returnUrl')
    //                 if (this.returnUrl) {
    //                   console.log(decodeURIComponent(this.returnUrl), 'decodeURIComponent(this.returnUrl)')
    //                   setTimeout(p => {
    //                     window.location.href = this.$commonJs.returnQuery2(decodeURIComponent(this.returnUrl), {})
    //                   }, 2000)
    //                   // window.localStorage.removeItem('appId')
    //                   // window.localStorage.removeItem('openId')
    //                   window.localStorage.removeItem('returnUrl')
    //                 } else {
    //                   this.$commonJs.closeWindow()
    //                   // window.localStorage.removeItem('appId')
    //                   // window.localStorage.removeItem('openId')
    //                   window.localStorage.removeItem('returnUrl')
    //                 }
    //               } else {
    //                 if (p2[0]) {
    //                   this.$router.push({
    //                     name: p2[0].url
    //                   })
    //                   setTimeout(p => {
    //                     window.location.reload()
    //                   }, 10)
    //                 } else {
    //                   this.$router.push({
    //                     name: 'noPermission'
    //                   })
    //                 }
    //               }
    //
    //             })
    //           }
    //         }
    //       })
    //       // let rolesMenu = await axiox.asyncGet('/api/employeerole/Gets?pageIndex=1&pageSize=9999')
    //       // console.log(rolesMenu)
    //       // Vue.prototype.$rolesMenu = rolesMenu
    //       // for (let i = 0; i < rolesMenu.length; i++) {
    //       //   if (rolesMenu[i].role === 'Administrator') {
    //       //     let adminList = await axiox.asyncGet('/api/employeerole/GetEmps?roleId=' + rolesMenu[i].id + '&PageSize=9999&PageIndex=1&')
    //       //     console.log(adminList)
    //       //     for (let j = 0; j < adminList.length; j++) {
    //       //       if (adminList[j].employeeId === loginInfo.id) {
    //       //         window.localStorage.setItem('isAdmin', 'true')
    //       //       } else {
    //       //         window.localStorage.setItem('isAdmin', 'false')
    //       //       }
    //       //     }
    //       //   }
    //       // }
    //     })
    //   })
    //   // this.goUrl()
    // }
    if (this.email) {
      console.log('this.email')
      window.location.href = process.env.config.baseUrl + '/Login?email=' + this.email
    }
  },
  methods: {// 所有的方法写在里面
    async goUrl () {
      let loginInfo = await this.$axiox.asyncGet('/Login/userinfo')
      let FinanceTeamList = await this.$axiox.asyncGet('/api/financereview/FinanceTeamTodoSummaryInfo')
      let AssistantList = await this.$axiox.asyncGet('/api/DepartmentAssistantSubmit/TodoSummaryInfo')
      let departAssistantList = await this.$axiox.asyncGet('/api/DepartmentAssistantSubmit/DepartmentAssistantTodoSummaryInfo')
      let MenuPermissions = await this.$axiox.asyncGet('/api/authoritymenu/usermenus?userId=' + loginInfo.id)
      let fatherMenuList = []
      let childMenuList = []
      for (let i = 0; i < MenuPermissions.length; i++) {
        if (MenuPermissions[i].url) {
          fatherMenuList.push(MenuPermissions[i].url)
        }
        if (MenuPermissions[i].childMenus) {
          for (let j = 0; j < MenuPermissions[i].childMenus.length; j++) {
            if (MenuPermissions[i].childMenus[j].url) {
              childMenuList.push(MenuPermissions[i].childMenus[j].url)
            }
          }
        }
      }
      if (fatherMenuList.length === 0 && childMenuList.length === 0) {
        // window.location.href = pubilshSet.baseUrl + '/ui/#/noPermission'
      }
      if (fatherMenuList) {
        if (fatherMenuList.length > 0) {
          this.$router.push({
            name: fatherMenuList[0]
          })
        } else {
          if (childMenuList.length > 0) {
            this.$router.push({
              name: childMenuList[0]
            })
          } else {
            this.$router.push({
              name: 'index'
            })
          }
        }
      } else {
        this.$router.push({
          name: 'index'
        })
      }
      Vue.prototype.$loginInfo = loginInfo
      Vue.prototype.$FinanceTeamList = FinanceTeamList
      Vue.prototype.$AssistantList = AssistantList
      Vue.prototype.$fatherMenuList = fatherMenuList
      Vue.prototype.$departAssistantList = departAssistantList
      Vue.prototype.$childMenuList = childMenuList
      window.localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
      window.localStorage.setItem('FinanceTeamList', JSON.stringify(FinanceTeamList))
      window.localStorage.setItem('AssistantList', JSON.stringify(AssistantList))
      window.localStorage.setItem('departAssistantList', JSON.stringify(departAssistantList))
      setTimeout(p => {
        window.location.reload()
      }, 10)
    },
    goToIndex () {
      const that = this
      const data = {
        user_name: this.account,
        pass_word: this.myPassword
      }
      this.$axiox.post('/sysLogin', data).then(msg => {
        if (msg.status === 'Y') {
          window.localStorage.setItem('user_name', data.user_name)
          window.localStorage.setItem('sys_user_id', msg.response_context.sys_user_id)
          window.localStorage.setItem('last_login_time', msg.response_context.last_login_time)
          this.$router.push({
            name: 'index'
          })
        } else {
          that.$commonJs.alertTips({
            type: 'error',
            title: '错误:',
            content: msg.message,
            stayTime: 5
          })
        }
      }).catch(msg => {
        that.$commonJs.alertTips({
          type: 'error',
          title: '获取接口错误:',
          content: '服务器报错',
          stayTime: 5
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/redirectLogin.vue